import { render, staticRenderFns } from "./registerLd.vue?vue&type=template&id=5ed1cb22&scoped=true"
import script from "./registerLd.vue?vue&type=script&lang=js"
export * from "./registerLd.vue?vue&type=script&lang=js"
import style0 from "./registerLd.vue?vue&type=style&index=0&id=5ed1cb22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed1cb22",
  null
  
)

export default component.exports